import { IHowItWorkItemProps } from '../../../components/HowItWork';
import { IApplicationContext } from '../../../types/applicationContext';

const HOW_IT_WORK_REFERALL_ITEMS: IHowItWorkItemProps[] = [
  {
    stepNumber: 1,
    title: 'Звонок',
    description: 'Связываемся с вами, чтобы уточнить детали и подтвердить заявку',
  },
  {
    stepNumber: 2,
    title: 'Подбор агента',
    description: 'Назначаем агента, чей опыт максимально близок вашему запросу',
  },
  {
    stepNumber: 3,
    title: 'Подготовка к сделке',
    description: 'Агент с вами на каждом этапе — неважно, покупаете вы или продаёте',
  },
  {
    stepNumber: 4,
    title: 'Сделка',
    description: 'Агент помогает собрать документы, проверяет договор и помогает на сделке',
  },
];

const HOW_IT_WORK_REFERRER_ITEMS: IHowItWorkItemProps[] = [
  {
    stepNumber: 1,
    title: 'Пригласите друга по ссылке',
    description: 'Ссылку привяжем к вашему номеру телефона для надёжности',
  },
  {
    stepNumber: 2,
    title: 'Дождитесь, когда пройдёт сделка',
    description: 'За статусом можно будет следить на этой странице',
  },
  {
    stepNumber: 3,
    title: 'Получите выплату',
    description:
      'На следующий месяц после сделки вы получите смс с инструкцией, как вывести деньги — она придёт не позднее 15-го числа',
  },
];

export const getHowItWorkProps = (
  pageType: IApplicationContext['custom']['pageType'],
): {
  title: string;
  className: 'wrapper-3-colum' | 'wrapper-4-colum';
  items: IHowItWorkItemProps[];
} => {
  if (pageType === 'referral') {
    return {
      title: 'Как работает Сделка',
      className: 'wrapper-4-colum',
      items: HOW_IT_WORK_REFERALL_ITEMS,
    };
  }

  return {
    title: 'Как получить вознаграждение',
    className: 'wrapper-3-colum',
    items: HOW_IT_WORK_REFERRER_ITEMS,
  };
};
